/**
 * 订单类型配置
 * 定义每种订单类型的配置信息
 */

// 订单状态配置
export const ORDER_STATUS_CONFIG = {
  abnormal: { text: '异常订单', color: 'red' },
  normal: { text: '正常订单', color: 'green' },
  overtime: { text: '超时订单', color: 'orange' },
  pending: { text: '待支付', color: 'default' },
  booked: { text: '已预约', color: 'blue' },
  in_progress: { text: '进行中', color: 'processing' },
  completed: { text: '已完成', color: 'success' }
}

// 服务类型配置
export const SERVICE_TYPE_CONFIG = {
  maternity: { text: '产康', color: 'purple' },
  nursing: { text: '护理', color: 'cyan' },
  home: { text: '到家', color: 'geekblue' }
}

// 订单状态选项（月子中心）
export const ORDER_STATUS_OPTIONS = [
  { id: '1', value: '在住' },
  { id: '2', value: '续住' },
  { id: '3', value: '已顺利离院' }
]
// 订单状态选项（通用）
export const NOW_STATUS_OPTIONS = [
  { id: '1', value: '当前' },
  { id: '2', value: '过去' },
  { id: '3', value: '已取消' }
]
// 套餐状态选项（月子中心）
export const PACKAGE_TYPE_OPTIONS = [
  { id: '1', value: '待入住' },
  { id: '2', value: '温馨入住中' },
  { id: '3', value: '已顺利离院' }
]
// 服务类型选项（月子中心和到家服务使用）
export const SERVICE_TYPE_OPTIONS = [
  { id: 'maternity', value: '产康' },
  { id: 'nursing', value: '护理' },
  { id: 'home', value: '到家' }
]

// 订单类型配置（仅 text/key 用于 Tabs 与 URL 校验，表格与接口由各自模块维护）
export const ORDER_TYPE_CONFIG = {
  maternity_center: { text: '月子中心', key: 'maternity_center' },
  // home_service: { text: '到家', key: 'home_service' },
  // traditional_medicine: { text: '中医', key: 'traditional_medicine' },
  // dental: { text: '牙医', key: 'dental' }
}

// 订单类型列表
export const ORDER_TYPE_LIST = Object.values(ORDER_TYPE_CONFIG)

// 获取订单类型配置
export const getOrderTypeConfig = (orderType) => {
  return ORDER_TYPE_CONFIG[orderType] || ORDER_TYPE_CONFIG.maternity_center
}

// ==================== 订单详情展示用选项 ====================

/** 否/是（0 否，1 是）- 用于个性化服务、是否使用电子卡支付等 */
export const YES_NO_01_OPTIONS = [
  { id: 0, value: '否' },
  { id: 1, value: '是' }
]

/** 当前类型：1 正常 2 转出（带确定）3 转出 4 转入 5 已取消 */
export const CURRENT_TYPE_OPTIONS = [
  { id: 1, value: '正常' },
  { id: 2, value: '转出（待确定）' },
  { id: 3, value: '转出' },
  { id: 4, value: '转入' },
  { id: 5, value: '已取消' }
]

/** 财务审核状态：0 未结算，1 待审核，2 已审核，3 未复核 */
export const FINANCIAL_AUDIT_OPTIONS = [
  { id: 0, value: '未结算' },
  { id: 1, value: '待审核' },
  { id: 2, value: '已审核' },
  { id: 3, value: '未复核' }
]

/** 订单类型（单据）：1 正常单 2 被红冲 3 红单 4 蓝单 */
export const ORDER_BILL_TYPE_OPTIONS = [
  { id: 1, value: '正常单' },
  { id: 2, value: '被红冲' },
  { id: 3, value: '红单' },
  { id: 4, value: '蓝单' }
]

/** 是否是全款：1 是，2 否 */
export const IS_FULL_PAYMENT_OPTIONS = [
  { id: 1, value: '是' },
  { id: 2, value: '否' }
]

/** 支付状态 */
export const PAY_STATE_OPTIONS = [
  { id: 1, value: '已支付' },
  { id: 2, value: '未支付' }
]
/** 免单状态 */
export const FREE_SINGLE_STATUS_OPTIONS = [
  { id: 1, value: '普通单' },
  { id: 2, value: '超级客户' },
  { id: 2, value: '员工福利' }
]

/** 代金券状态 */
export const VOUCHER_GIFT_STATUS_OPTIONS = [
  { id: 0, value: '未使用' },
  { id: 1, value: '已使用' },
  { id: 2, value: '已作废' }
]

/** 根据选项列表和 code 取展示文案 */
export const getOptionLabel = (options, code) => {
  if (code == null || code === '') return '-'
  const item = options.find(opt => opt.id === code || opt.id === Number(code))
  return item ? item.value : '-'
}
